import React from 'react';
import {
  Edit,

  SimpleForm,

  DateField,
  TextInput,
  NumberInput,

  CardActions,
  ListButton,
} from 'react-admin';

import { isPostiveDecimal } from '../../validators';

const Title = ({ record }) => (
  <span>PrivateQuote: <strong>{record.id} {record.name}</strong></span>
);


const Actions = ({ basePath }) => (
  <CardActions>
    <ListButton basePath={basePath} />
  </CardActions>
);


export default props => (
  <Edit
    {...props}
    title={<Title />}
    actions={<Actions />}
    undoable={false}
  >
    <SimpleForm>
      <TextInput source="ticker" label="Ticker Symbol" />
      <DateField source="updatedAt" />
      <DateField source="createdAt" />
      <NumberInput source="purchasePrice" validate={isPostiveDecimal} />
      <NumberInput source="currentPrice" validate={isPostiveDecimal} />
    </SimpleForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/PrivateQuote/Edit.js